import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Follower } from '../models';

@Injectable({
  providedIn: 'root',
})
export class FollowersService {
  private apiUrl = environment.apiUrl; // Misma URL base que AuthService
  private followersSubject = new BehaviorSubject<Follower[]>([]);
  public followers$ = this.followersSubject.asObservable();
  private followingSubject = new BehaviorSubject<Follower[]>([]);
  public following$ = this.followingSubject.asObservable();

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    console.log('[FollowersService] Inicializando servicio');
  }

  followUser(followingId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/follow`, {
      following_id: followingId,
    });
  }

  unfollowUser(followingId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/unfollow/${followingId}`);
  }

  isFollowing(followingId: number): Observable<boolean> {
    return this.http
      .get<boolean>(`${this.apiUrl}/is-following/${followingId}`)
      .pipe(
        catchError((error) => {
          console.error('Error en isFollowing:', error);
          return of(false);
        }),
      );
  }
}
